<div
  *ngIf="lifeChangeItem"
  class="pl-lifeChange relative flex w-full flex-col items-center justify-center p-5"
  [ngClass]="{
    'bg-pl-gray-100 shadow-md': !isEditMode || lifeChangeItem.title
  }"
>
  <ng-container *ngIf="isEditMode; else displayMode">
    <pl-input
      class="mb-5 w-full"
      required
      [isFormSubmitted]="true"
      [showRightIcon]="false"
      [label]="lifeChangeItem.title ? '' : ('blocks.lifeChanges.write_one_line_summary' | translate)"
      [(ngModel)]="titleNgModel"
      (specialKeyPressed)="onSpecialKeyPressed($event)"
    />

    <div class="flex w-full justify-center gap-10">
      <pl-button
        class="!w-fit"
        [variant]="ButtonVariant.lightGray"
        [padding]="ButtonPadding.big"
        (click)="onCancelClicked()"
      >
        {{ 'utils.cancel' | translate }}
      </pl-button>
      <pl-button
        class="!w-fit"
        [isDisabled]="!titleNgModel"
        [variant]="ButtonVariant.lightOrange"
        [padding]="ButtonPadding.big"
        (click)="onSaveClicked()"
      >
        {{ 'utils.save' | translate }}
      </pl-button>
    </div>
  </ng-container>
  <ng-template #displayMode>
    <pl-icon
      [frame]="IconFrame.round"
      [name]="PlIcon.close"
      (click)="onDeleteLifeChange()"
      class="absolute left-2 top-2 h-8 w-8 cursor-pointer border-transparent bg-pl-gray-300 text-pl-gray-700 hover:bg-gray-400"
    />

    <pl-icon
      [frame]="IconFrame.round"
      [name]="PlIcon.pen_to_square"
      (click)="enterEditMode()"
      class="absolute right-2 top-2 h-8 w-8 cursor-pointer border-transparent bg-pl-gray-300 text-pl-gray-700 hover:bg-gray-400"
    />

    <h4 class="mb-5 w-full truncate px-10 text-center">{{ lifeChangeItem.title }}</h4>
    <div class="w-full px-2">
      <pl-slider
        [max]="LifeChangeStatus.habit"
        [min]="LifeChangeStatus.notStarted"
        [step]="1"
        [showTicks]="true"
        [(ngModel)]="lifeChangeItem.status"
        (ngModelChange)="onSliderChange()"
      />
    </div>
    <div class="flex w-full justify-between">
      <p *ngFor="let status of statusLabels">
        <span
          class="pl-gray-450 font-bold"
          [ngClass]="{
            hidden: status.value !== lifeChangeItem.status
          }"
        >
          {{ status.label }}
        </span>
      </p>
    </div>
  </ng-template>
</div>
